/* eslint-disable react/no-unknown-property */
import _ from "lodash";
import React from "react";
import styled from "styled-components";

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${({ backgroundColor = "black" }) => backgroundColor};
`;

const Text = styled.div`
  color: ${({ color = "white" }) => color};
  font-size: ${({ fontSize = "16px" }) => fontSize};
  font-family: ${({ fontFamily = "IBM Plex Sans Thai" }) => fontFamily};
  white-space: nowrap;
`;

export const ScrollingText = ({ attribute }) => {
  const text = _.get(attribute, ["text"], "TENT");
  const direction = _.get(attribute, ["direction"], "left"); // left , right
  const fontSize = _.get(attribute, ["fontSize"]);
  const color = _.get(attribute, ["color"]);
  const speed = _.get(attribute, ["speed"], 10);
  const fontFamily = _.get(attribute, ["fontFamily"]);
  const backgroundColor = _.get(attribute, ["backgroundColor"]);
  const isFreeze = _.get(attribute, ["isFreeze"], false);

  return (
    <Container backgroundColor={backgroundColor}>
      {isFreeze ? (
        <Text color={color} fontSize={fontSize} fontFamily={fontFamily}>
          {text}
        </Text>
      ) : (
        <marquee direction={direction} scrollamount={speed}>
          <Text color={color} fontSize={fontSize} fontFamily={fontFamily}>
            {text}
          </Text>
        </marquee>
      )}
    </Container>
  );
};
